<template>
  <v-card flat class="mb-5">
    <v-card-text class="px-7">
      <template v-if="isBuka">
        <v-row>
          <v-col cols="12" lg="6">
            <div class="body-2">Tanggal Pelaksanaan</div>
            <div class="body-1 black--text">{{ $localDate(laporan.tgl_monev) || '-' }}</div>
          </v-col>
          <v-col v-if="!isBalai" cols="12" lg="6">
            <div class="body-2">Moda Penyelenggaraan IHT</div>
            <div class="body-1">{{ $getDeepObj(laporan, 'm_monev_moda_psp.data.keterangan') || '-' }}</div>
          </v-col>
        </v-row>
        <div class="mt-5">
          <h2 class="black--text">
            Pihak luar satuan pendidikan yang hadir <span class="grey--text font-weight-regular">(Jumlah Orang)</span>
          </h2>
          <v-row class="mt-1">
            <v-col v-for="(perwakilan, id) in perwakilans" :key="id" cols="12" lg="3" class="py-2">
              <div class="body-2">{{ perwakilan.label }}</div>
              <span class="black--text body-1">
                {{ +perwakilan.jumlah > 0 ? `${perwakilan.jumlah} Orang` : 'Tidak Ada' }}
              </span>
            </v-col>
          </v-row>
        </div>
        <div class="mt-5">
          <h2 class="black--text">
            Uraian Pelaksanaan IHT
          </h2>
          <v-row class="mt-1">
            <v-col v-for="(uraian, id) in uraians" :key="id" cols="12" class="py-2">
              <div class="body-2">{{ uraian.label }}</div>
              <p class="black--text body-1 text-justify" v-html="uraian.value"></p>
            </v-col>
          </v-row>
        </div>
        <div v-if="isBalai" class="mt-5">
          <h2 class="black--text">
            Hambatan dan Dukungan
          </h2>
          <v-row class="mt-1">
            <v-col v-for="(evaluasi, id) in evaluasis" :key="id" cols="12" class="py-2">
              <div class="body-2">{{ evaluasi.label }}</div>
              <p class="black--text body-1 text-justify" v-html="evaluasi.value"></p>
            </v-col>
          </v-row>
        </div>
        <div class="mt-5">
          <foto-kegiatan :berkases="berkas.foto" />
        </div>
        <div class="mt-5">
          <foto-absensi :berkas="berkas.absensi" />
        </div>
      </template>
      <template v-else>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-icon x-large color="grey" style="font-size: 6rem" class="mb-3">mdi-file-alert</v-icon>
            <h2>Laporan IHT Tidak Tersedia</h2>
            <div class="body-2">
              Hal ini dikarenakan pihak terkait belum mengirimkan laporannya
            </div>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import FotoAbsensi from '../base/absensi';
import FotoKegiatan from '../base/foto';
import { mapState } from 'vuex';

export default {
  name: 'IhtTutup',
  components: { FotoAbsensi, FotoKegiatan },
  props: {
    laporan: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState('preferensi', {
      isBalai: (state) => (state.data && state.data.balai) || false,
    }),

    isBuka() {
      return this.laporan.k_verval_psp > 1;
    },

    perwakilans() {
      return [
        { label: 'Perwakilan Dinas Pendidikan', jumlah: this.laporan.jml_hadir_dinas || 0 },
        { label: 'Pengawas Sekolah', jumlah: this.laporan.jml_hadir_pengawas || 0 },
        { label: 'Perwakilan UPT/BGP/BBGP', jumlah: this.laporan.jml_hadir_upt || 0 },
        { label: 'Fasilitator Sekolah Penggerak', jumlah: this.laporan.jml_hadir_fasilitator || 0 },
        { label: 'Pihak Lainnya (Pengamat)', jumlah: this.laporan.jml_hadir_lain || 0 },
      ];
    },

    uraians() {
      let catatans = {};
      const instrumens = this.$getDeepObj(this.laporan, 'psp_monev_instrumens.data') || [];
      for (const ins of instrumens) {
        catatans[ins.k_monev_instrumen_psp] = ins.catatan || '';
      }

      return [
        { label: 'Latar Belakang dan Tujuan Kegiatan', value: catatans[1] || '' },
        { label: 'Hal-hal efektif terkait Konten/Materi', value: catatans[11] || '' },
        { label: 'Hal-hal efektif terkait Pelaksanaan IHT', value: catatans[12] || '' },
        { label: 'Hal-hal tidak efektif terkait Konten/Materi', value: catatans[13] || '' },
        { label: 'Hal-hal tidak efektif terkait Pelaksanaan IHT', value: catatans[14] || '' },
        { label: 'Rencana Tindak Lanjut IHT', value: catatans[15] || '' },
      ];
    },

    evaluasis() {
      let catatans = {};
      const instrumens = this.$getDeepObj(this.laporan, 'psp_monev_instrumens.data') || [];
      for (const ins of instrumens) {
        catatans[ins.k_monev_instrumen_psp] = ins.catatan || '';
      }

      return [
        { label: 'Hambatan yang ditemui selama proses IHT', value: catatans[16] || '' },
        { label: 'Dukungan yang diperlukan agar proses IHT semakin baik', value: catatans[17] || '' },
      ];
    },

    berkas() {
      const absensi = (this.$getDeepObj(this.laporan, 'psp_monev_berkases.data') || []).filter(
        (berkas) => +berkas.k_monev_berkas_psp === 4
      );
      const foto = (this.$getDeepObj(this.laporan, 'psp_monev_berkases.data') || []).filter((berkas) =>
        [1, 2, 3].includes(+berkas.k_monev_berkas_psp)
      );

      return {
        absensi: this.$getDeepObj(absensi[0], 'url_berkas'),
        foto: foto.map((file) => {
          return file.url_berkas;
        }),
      };
    },

    tautans() {
      return [
        {
          color: 'primary',
          size: 6,
          content: [
            '<h2 class="black--text">Tautan Post Test</h2>',
            '<p class="black--text mt-2">Berikut adalah tautan post test sesuai UPT perwalian Anda</p>',
          ].join(''),
          contentButton: 'Post Test',
          link: this.laporan.url_posttest || '',
        },
        {
          color: 'orange',
          size: 6,
          content: [
            '<h2 class="black--text">Tautan Evaluasi</h2>',
            '<p class="black--text mt-2">Berikut adalah tautan evaluasi sesuai UPT perwalian Anda</p>',
          ].join(''),
          contentButton: 'Evaluasi',
          link: this.laporan.url_evaluasi || '',
        },
      ];
    },
  },
};
</script>

<style scoped></style>
